import { toRefs, computed } from 'vue';
import uniqueId from 'lodash/uniqueId';
import RatioBox from '../ratio-box/component-lib.esm.js';
import CheckIcon from '../../icons/component-lib.esm14.js';
import { useGroupItem } from '../../compositions/component-lib.esm20.js';

//
const InputBtnProps = {
  inputAttrs: {
    type: Object,
    default: null
  },
  value: {
    type: String,
    default: null
  },
  contentHeight: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: 'radio'
  },
  checked: Boolean,
  disabled: Boolean,
  ratio: {
    type: Number,
    default: 2 / 3
  },
  centerContent: Boolean
};
var script = {
  name: 'InputBtn',
  components: {
    RatioBox,
    CheckIcon
  },
  props: InputBtnProps,
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      checked,
      value,
      disabled
    } = toRefs(props);
    const inputId = uniqueId('input-btn-');
    const {
      isInGroup,
      onToggle,
      isSelected,
      size
    } = useGroupItem(value, 'input-group');
    const isInput = computed(() => {
      return props.type === 'radio';
    });
    const rootAttrs = computed(() => {
      if (isInput.value) return {};
      return {
        type: 'button',
        disabled: props.disabled
      };
    });
    const isChecked = computed(() => {
      return isSelected.value || checked.value;
    });
    const classes = computed(() => {
      return {
        'v-input-btn--checked': isChecked.value,
        'v-input-btn--disabled': disabled.value,
        [`v-input-btn--${props.type}`]: true,
        [`v-input-btn--group-${size === null || size === void 0 ? void 0 : size.value}`]: size,
        'v-input-btn--centered': props.centerContent
      };
    });
    const checkIconSize = computed(() => {
      switch (size === null || size === void 0 ? void 0 : size.value) {
        case 'xs':
          return '1.25rem';
        case 'sm':
          return '1.35rem';
        default:
          return '1.75rem';
      }
    });
    function handleClick(e) {
      if (disabled.value) return;
      emit('click', e);
      if (isInGroup) onToggle(value.value);
    }
    return {
      inputId,
      classes,
      isChecked,
      handleClick,
      isInput,
      rootAttrs,
      checkIconSize
    };
  }
};
export { InputBtnProps, script as default };